module.exports = __webpack_public_path__ + "static/media/home-hero.a26020d1.png";